module.exports = __webpack_public_path__ + "img/sora-min.da7e7377.png";